import {
  colors,
  layers,
  media,
  radius,
  shadows,
  spacing,
} from '@lamimed/pantheon';
import styled, { css } from 'styled-components';

export const Overlay = styled.div<{ isOpen: boolean }>`
  ${({ isOpen }) => css`
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: ${layers.modal};
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    transition: opacity 0.3s ease, visibility 0.3s ease;

    ${isOpen &&
    css`
      opacity: 1;
      visibility: visible;
      pointer-events: initial;
    `}
  `}
`;

export const Container = styled.div<{ isOpen: boolean }>`
  ${({ isOpen }) => css`
    background-color: ${colors.light};
    border-radius: ${radius.medium};
    box-shadow: ${shadows.default};
    padding: ${spacing.xlarge};
    position: relative;
    width: 90%;
    max-width: 50rem;
    max-height: 90vh;
    overflow-y: auto;
    transform: translateY(2rem);
    opacity: 0;
    transition: transform 0.3s ease, opacity 0.3s ease;

    ${isOpen &&
    css`
      transform: translateY(0);
      opacity: 1;
    `}

    ${media.greaterThan('tablet')`
      padding: ${spacing.xlarge};
    `}
  `}
`;

export const CloseButton = styled.button`
  position: absolute;
  top: ${spacing.small};
  right: ${spacing.small};
  background: none;
  border: none;
  cursor: pointer;
  font-size: 2.4rem;
  line-height: 1;
  color: ${colors.dark};
  padding: ${spacing.small};
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    opacity: 0.7;
  }
`;

export const Title = styled.h2`
  font-size: 2.4rem;
  font-weight: 700;
  color: ${colors.dark};
  margin-bottom: ${spacing.medium};
  padding-right: ${spacing.large};
`;

export const Body = styled.div`
  font-size: 1.6rem;
  color: ${colors.dark};
  line-height: 1.5;
  margin-bottom: ${spacing.large};
`;

export const CTALink = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: ${spacing.small} ${spacing.large};
  background-color: ${colors.primary};
  color: ${colors.light};
  border: none;
  border-radius: ${radius.medium};
  font-size: 1.6rem;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.85;
  }
`;
